module.exports = __webpack_public_path__ + "img/v6.35d9728.png";